const SponsorPane = () => {
  const vallumLogo = 'https://assets.bluestar-rowing.com/assets/logos/VallumWealthLogo_Primary_Vertical.png';
  const sageLogo = 'https://assets.bluestar-rowing.com/assets/logos/Sage_WM_Logo.jpg';
  const attireKitSponsorLogo = 'https://assets.bluestar-rowing.com/assets/logos/attire-original.svg';
  const mcmGroupLogo = 'https://assets.bluestar-rowing.com/assets/logos/MCM_Pantone.jpg';
  const speedflexLogo = 'https://assets.bluestar-rowing.com/assets/logos/speedflex-silver.png';
  const woodberryLogo = 'https://assets.bluestar-rowing.com/assets/logos/woodberry-logo-high-res.png';

  return (
    <section
      className="section-seamless hero-sponsor-section"
      style={{
        position: 'relative',
        zIndex: 2,
        background: '#000000',
        padding: '32px 20px 34px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      <h2
        style={{
          color: 'white',
          fontSize: 'clamp(1.2rem, 2vw, 1.5rem)',
          fontWeight: '400',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          margin: 0,
          textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
        }}
      >
        Sponsored By
      </h2>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '80px',
          flexWrap: 'wrap',
          padding: '20px 40px',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}
      >
        <a href="https://www.vallumwealth.co.uk" target="_blank" rel="noopener noreferrer">
          <img
            className="sponsor-logo"
            src={vallumLogo}
            alt="Vallum Wealth Consulting"
            style={{
              maxHeight: '70px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
        </a>
        <a href="https://www.sagewm.co.uk" target="_blank" rel="noopener noreferrer">
          <img
            className="sponsor-logo"
            src={sageLogo}
            alt="Sage Wealth Management"
            style={{
              maxHeight: '70px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
        </a>
        <img
          className="sponsor-logo"
          src={mcmGroupLogo}
          alt="MCM Group"
          style={{
            maxHeight: '70px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
        <img
          className="sponsor-logo"
          src={attireKitSponsorLogo}
          alt="Attire Kit Sponsor"
          style={{
            maxHeight: '70px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
        <img
          className="sponsor-logo sponsor-logo-speedflex"
          src={speedflexLogo}
          alt="Speedflex"
          style={{
            maxHeight: '35px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
        <img
          className="sponsor-logo"
          src={woodberryLogo}
          alt="Woodberry Capital"
          style={{
            maxHeight: '70px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
      </div>
    </section>
  );
};

export default SponsorPane;
